export default "__VITE_ASSET__DG3q_z$5__"